import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ResumeState = {
  // 実施中トレーニングのセンテンスID
  sentenceId: string;
  // 実施中トレーニングのトレーニングID
  trainingId: number;
};

const initialState: ResumeState = {
  sentenceId: '',
  trainingId: -1,
};

const resumeSlice = createSlice({
  name: 'resume',
  initialState,
  reducers: {
    saveSentenceId: (state, action: PayloadAction<string>) => {
      state.sentenceId = action.payload;
    },
    saveTrainingId: (state, action: PayloadAction<number>) => {
      state.trainingId = action.payload;
    },
  },
});

export { resumeSlice };
export type { ResumeState };
